import {Swappable} from '@shopify/draggable';

import SoundFx from '../../../components/SoundFx';

export default function SwappableSection() {
  const containers = document.querySelectorAll('.CubesFrame--idSwappable .Cube');
  const draggable = new Swappable(containers);
  let swappedNode = null;

  // --- Drag states --- //
  draggable.on('drag:start', () => {
    SoundFx.Synth.play('up');
  });

  draggable.on('swappable:swapped', ({swappedElement}) => {
    swappedNode = swappedElement;
    SoundFx.Synth.play('swap');
  });

  draggable.on('drag:stop', () => {
    if (swappedNode) {
      SoundFx.Synth.play('downGood');
    } else {
      SoundFx.Synth.play('downBad');
    }

    swappedNode = null;
  });

  return draggable;
}
